import { COOKIE_DECLINE, COOKIE_OK } from "../Analytics/constants"

// TODO: these are not being used?
export const toggleMenu = () => ({ type: "TOGGLE_MENU" })
export const cookieOk = () => ({ type: COOKIE_OK })
export const cookieDecline = () => ({ type: COOKIE_DECLINE })
export const homeClicked = () => ({ type: "HOME_CLICKED" })
